exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.cp-robot .tabs {\n  width: 100%;\n  text-align: center;\n  height: 48px;\n  line-height: 48px;\n  border-top: 1px solid #eae9e9;\n  box-shadow: 0 3px 10px #eae9e9;\n}\n.cp-robot .tabs.fixed {\n  position: fixed;\n  top: 0;\n  left: 0;\n  background: rgba(255,255,255,0.8);\n  z-index: 10;\n}\n.cp-robot .tabs a {\n  display: inline-block;\n  margin: 0 18px;\n  cursor: pointer;\n  font-size: 14px;\n}\n.cp-robot .tabs a.router-link-active {\n  color: #3bc0bc;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7ae5b5c6","scoped":false,"hasInlineConfig":false}!./node_modules/stylus-loader?{"paths":"D://workspace//flyingwings//zh-www//flwweb//flwweb//src//stylus","sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/robot/2s/index.vue
// module id = gTka
// module chunks = 0